import React from 'react';
import { Helmet } from 'react-helmet-async';

function Accessibility() {
	return (
		<section className="section">
			<div className="container">
				<Helmet>
					<title>Accessibility • Appex Connect Hub</title>
					<meta name="description" content="Accessibility commitment for Appex Connect Hub." />
				</Helmet>
				<h2>Accessibility</h2>
				<p className="helper">
					We aim to make our website accessible to all users and are committed to improving usability. If you encounter
					any barriers, please contact us so we can assist and remediate issues promptly.
				</p>
			</div>
		</section>
	);
}

export default Accessibility;


